import { MaterialMatcher } from './material-matcher'

export class WorkItemMatcher {
  public materialMatcher: MaterialMatcher = new MaterialMatcher()

  /**
   * If not empty, the work item must have one of the given labels.
   */
  public allowedLabels: string[] = []
}
